export default "__VITE_ASSET__994c9ff1__"